import { render } from "./DynamicTable.vue?vue&type=template&id=50ebbbeb&scoped=true"
import script from "./DynamicTable.vue?vue&type=script&lang=js"
export * from "./DynamicTable.vue?vue&type=script&lang=js"

import "./DynamicTable.vue?vue&type=style&index=0&id=50ebbbeb&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ebbbeb"]])

export default __exports__